import {api_url} from "../config/constant";

const axios = require('axios')

export const Methods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
}

export const makeRequest = (url, type, params, extraHeaders) => {
  return new Promise((resolve, reject) => {
    if (!url.startsWith('http')) url = api_url + url

    let headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }
    if(extraHeaders)
      headers = {...headers, ...extraHeaders}

    let options = {
      method: type,
      headers,
    }
    if (type !== Methods.DELETE && type !== Methods.GET && params) {
      options.data = params;
    }

    axios
      .request(url, options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      })
  })
}
